export default "__VITE_ASSET__98f08de5__"